import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ItemUpdatedResponse} from '../../entities';
import {Tab, TabCollectionResponse} from './entities';
import {ApiService} from '../base';

@Injectable({
  providedIn: 'root'
})
export class UserTabsRepositoryService {

  constructor(private api: ApiService) {
  }

  getTabs(): Observable<Tab[]> {
    return this.api.get<TabCollectionResponse>('usertabs')
      .pipe(map(result => result.items));
  }

  updateTabs(tabs: Tab[]) {
    const model = {
      tabs: tabs
    };
    return this.api.post<ItemUpdatedResponse>('usertabs', model)
      .pipe(map(result => result));
  }

}
